
import { Bar } from "vue-chartjs";

const MAX_CHAR_PER_LINE = 12;

function wrapLabel(text: string): string[] {
  const lines: string[] = [];
  let line = "";
  text.split(" ").forEach(word => {
    if (line && (line + " " + word).length > MAX_CHAR_PER_LINE) {
      lines.push(line);
      line = word;
    } else {
      line = line ? line + " " + word : word;
    }
  });
  if (line) lines.push(line);
  return lines.length ? lines : [text];
}

export default {
  extends: Bar,
  props: {
    labels: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    seriesLabel: { type: String, default: "Kunjungan" },
    color: { type: String, default: "#1976D2" },
    wrap: { type: Boolean, default: true }
  },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: this.seriesLabel,
            data: this.data,
            backgroundColor: this.color,
            maxBarThickness: 48
          }
        ]
      };
    },
    options() {
      const wrap = this.wrap;
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        layout: { padding: { top: 16 } },
        scales: {
          yAxes: [
            {
              id: "bar-y",
              ticks: { beginAtZero: true, precision: 0 }
            }
          ],
          xAxes: [
            {
              id: "bar-x",
              ticks: {
                autoSkip: !wrap,
                maxRotation: 0,
                minRotation: 0,
                fontSize: 11,
                callback: (value: string) =>
                  wrap ? wrapLabel(String(value)) : value
              }
            }
          ]
        }
      };
    }
  },
  data() {
    return {
      valueLabelPlugin: {
        afterDatasetsDraw(chart: any) {
          const ctx = chart.ctx;
          ctx.save();
          ctx.font = "11px Roboto, sans-serif";
          ctx.fillStyle = "#424242";
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";
          chart.data.datasets.forEach((dataset: any, i: number) => {
            const meta = chart.getDatasetMeta(i);
            if (meta.hidden) return;
            meta.data.forEach((element: any, index: number) => {
              const value = dataset.data[index];
              if (!value) return;
              ctx.fillText(String(value), element._model.x, element._model.y - 4);
            });
          });
          ctx.restore();
        }
      }
    };
  },
  mounted() {
    this.addPlugin(this.valueLabelPlugin);
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.renderChart(this.chartData, this.options);
      }
    }
  }
};
